'use client'
import { Grid, Stack } from '@mantine/core'
import React from 'react'
import { useDashStyles } from '../styles/DashboardStyle'
import { WarningCard } from './WarningCard'
import { ModulesCard } from './ModuleCard'
import { NewFeatureCard, TrainingCard } from './NewFeatures'
import { UserCard, UserChangesComp } from './UserCard'

export const PageDashboard = () => {
  const { classes, cx, theme } = useDashStyles()

  return (
    <Grid gutter={'xl'} p={0}>
      <Grid.Col sm={4} md={8}>
        <UserCard theme={theme} classes={classes} />
        <ModulesCard theme={theme} classes={classes} />
        <NewFeatureCard theme={theme} classes={classes} />
        <TrainingCard theme={theme} classes={classes} />
        {/* <DocVaultCard theme={theme} classes={classes} /> */}
      </Grid.Col>
      <Grid.Col sm={4} md={4}>
        <Stack>
          <WarningCard theme={theme} classes={classes} />
          <UserChangesComp theme={theme} classes={classes} />
        </Stack>
      </Grid.Col>
    </Grid>
  )
}

export default PageDashboard
